// LIST
export const loadSingleSitesListStart = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_START", ...params };
};
export const loadSingleSitesListSuccess = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_SUCCESS", ...params, };
};
export const loadSingleSitesListFailed = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_FAILED", ...params };
};
export const loadSingleSitesListCancel = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_CANCEL", ...params };
};

// LIST LIVE REFRESH
export const loadSingleSitesListRefreshStart = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_REFRESH_START", ...params };
};
export const loadSingleSitesListRefreshSuccess = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_REFRESH_SUCCESS", ...params, };
};
export const loadSingleSitesListRefreshFailed = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_REFRESH_FAILED", ...params };
};
export const loadSingleSitesListRefreshCancel = params => {
  return { type: "LOAD_SINGLE_SITES_LIST_REFRESH_CANCEL", ...params };
};

// TIMEFRAME
export const changeSingleSitesTimeframe = params => {
  return { type: "CHANGE_SINGLE_SITES_TIMEFRAME", ...params };
};

// CURRENT SITE
export const loadSingleSiteViewStart = params => {
  return { type: "LOAD_SINGLE_SITE_VIEW_START", ...params };
};
export const loadSingleSiteViewSuccess = params => {
  return { type: "LOAD_SINGLE_SITE_VIEW_SUCCESS", ...params };
};
export const loadSingleSiteViewFailed = params => {
  return { type: "LOAD_SINGLE_SITE_VIEW_FAILED", ...params };
};
export const loadSingleSiteViewCancel = params => {
  return { type: "LOAD_SINGLE_SITE_VIEW_CANCEL", ...params };
};

// LOAD SITE CONTACTS/KEYHOLDERS
export const loadSingleSiteContactsStart = params => {
  return { type: "LOAD_SINGLE_SITE_CONTACTS_START", ...params };
};
export const loadSingleSiteContactsSuccess = params => {
  return { type: "LOAD_SINGLE_SITE_CONTACTS_SUCCESS", ...params };
};
export const loadSingleSiteContactsFailed = params => {
  return { type: "LOAD_SINGLE_SITE_CONTACTS_FAILED", ...params };
};
export const loadSingleSiteContactsCancel = params => {
  return { type: "LOAD_SINGLE_SITE_CONTACTS_CANCEL", ...params };
};

// ADD SITE CONTACT/KEYHOLDER
export const requestAddSinglesitecontactStart = params => {
  return { type: "REQUEST_ADD_SINGLESITECONTACT_START", ...params }; // types need to be formatted like this - see src/services/redux/reducers/sites/current/keyholderActions.js
};
export const requestAddSinglesitecontactSuccess = params => {
  return { type: "REQUEST_ADD_SINGLESITECONTACT_SUCCESS", ...params };
};
export const requestAddSinglesitecontactFailed = params => {
  return { type: "REQUEST_ADD_SINGLESITECONTACT_FAILED", ...params };
};
export const requestAddSinglesitecontactCancel = params => {
  return { type: "REQUEST_ADD_SINGLESITECONTACT_CANCEL", ...params };
};
export const requestAddSinglesitecontactNotified = params => {
  return { type: "REQUEST_ADD_SINGLESITECONTACT_NOTIFIED", ...params };
};

// UPDATE SITE CONTACT/KEYHOLDER
export const requestUpdateSinglesitecontactStart = params => {
  return { type: "REQUEST_UPDATE_SINGLESITECONTACT_START", ...params }; // types need to be formatted like this - see src/services/redux/reducers/sites/current/keyholderActions.js
};
export const requestUpdateSinglesitecontactSuccess = params => {
  return { type: "REQUEST_UPDATE_SINGLESITECONTACT_SUCCESS", ...params };
};
export const requestUpdateSinglesitecontactFailed = params => {
  return { type: "REQUEST_UPDATE_SINGLESITECONTACT_FAILED", ...params };
};
export const requestUpdateSinglesitecontactCancel = params => {
  return { type: "REQUEST_UPDATE_SINGLESITECONTACT_CANCEL", ...params };
};
export const requestUpdateSinglesitecontactNotified = params => {
  return { type: "REQUEST_UPDATE_SINGLESITECONTACT_NOTIFIED", ...params };
};

// REMOVE SITE CONTACT/KEYHOLDER
export const requestRemoveSinglesitecontactStart = params => {
  return { type: "REQUEST_REMOVE_SINGLESITECONTACT_START", ...params }; // types need to be formatted like this - see src/services/redux/reducers/sites/current/keyholderActions.js
};
export const requestRemoveSinglesitecontactSuccess = params => {
  return { type: "REQUEST_REMOVE_SINGLESITECONTACT_SUCCESS", ...params };
};
export const requestRemoveSinglesitecontactFailed = params => {
  return { type: "REQUEST_REMOVE_SINGLESITECONTACT_FAILED", ...params };
};
export const requestRemoveSinglesitecontactCancel = params => {
  return { type: "REQUEST_REMOVE_SINGLESITECONTACT_CANCEL", ...params };
};
export const requestRemoveSinglesitecontactNotified = params => {
  return { type: "REQUEST_REMOVE_SINGLESITECONTACT_NOTIFIED", ...params };
};

// MOVE SITE CONTACT/KEYHOLDER UP/DOWN
export const requestMoveSinglesitecontactStart = params => {
  return { type: "REQUEST_MOVE_SINGLESITECONTACT_START", ...params }; // types need to be formatted like this - see src/services/redux/reducers/sites/current/keyholderActions.js
};
export const requestMoveSinglesitecontactSuccess = params => {
  return { type: "REQUEST_MOVE_SINGLESITECONTACT_SUCCESS", ...params };
};
export const requestMoveSinglesitecontactFailed = params => {
  return { type: "REQUEST_MOVE_SINGLESITECONTACT_FAILED", ...params };
};
export const requestMoveSinglesitecontactCancel = params => {
  return { type: "REQUEST_MOVE_SINGLESITECONTACT_CANCEL", ...params };
};
export const requestMoveSinglesitecontactNotified = params => {
  return { type: "REQUEST_MOVE_SINGLESITECONTACT_NOTIFIED", ...params };
};

// LOAD NOTIFICATION RULES
export const loadSingleSiteNotificationsRulesStart = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATIONS_RULES_START", ...params };
};
export const loadSingleSiteNotificationsRulesSuccess = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATIONS_RULES_SUCCESS", ...params };
};
export const loadSingleSiteNotificationsRulesFailed = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATIONS_RULES_FAILED", ...params };
};
export const loadSingleSiteNotificationsRulesCancel = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATIONS_RULES_CANCEL", ...params };
};

// ADD NOTIFICATION RULE
export const singleSiteNotificationsAddRuleStart = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_ADD_RULE_START", ...params };
};
export const singleSiteNotificationsAddRuleSuccess = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_ADD_RULE_SUCCESS", ...params };
};
export const singleSiteNotificationsAddRuleFailed = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_ADD_RULE_FAILED", ...params };
};
export const singleSiteNotificationsAddRuleCancel = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_ADD_RULE_CANCEL", ...params };
};
export const singleSiteNotificationsAddRuleNotified = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_ADD_RULE_NOTIFIED", ...params };
};

// REMOVE NOTIFICATION RULE
export const singleSiteNotificationsRemoveRuleStart = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_REMOVE_RULE_START", ...params };
};
export const singleSiteNotificationsRemoveRuleSuccess = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_REMOVE_RULE_SUCCESS", ...params };
};
export const singleSiteNotificationsRemoveRuleFailed = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_REMOVE_RULE_FAILED", ...params };
};
export const singleSiteNotificationsRemoveRuleCancel = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_REMOVE_RULE_CANCEL", ...params };
};
export const singleSiteNotificationsRemoveRuleNotified = params => {
  return { type: "SINGLE_SITE_NOTIFICATIONS_REMOVE_RULE_NOTIFIED", ...params };
};

// LOAD NOTIFICATION HISTORY
export const loadSingleSiteNotificationHistoryStart = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATION_HISTORY_START", ...params };
};
export const loadSingleSiteNotificationHistorySuccess = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATION_HISTORY_SUCCESS", ...params };
};
export const loadSingleSiteNotificationHistoryFailed = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATION_HISTORY_FAILED", ...params };
};
export const loadSingleSiteNotificationHistoryCancel = params => {
  return { type: "LOAD_SINGLE_SITE_NOTIFICATION_HISTORY_CANCEL", ...params };
};

// LOAD SCHEDULES
export const loadSiteSchedulesStart = params => {
  return { type: "LOAD_SITE_SCHEDULES_START", ...params };
};
export const loadSiteSchedulesSuccess = params => {
  return { type: "LOAD_SITE_SCHEDULES_SUCCESS", ...params };
};
export const loadSiteSchedulesFailed = params => {
  return { type: "LOAD_SITE_SCHEDULES_FAILED", ...params };
};
export const loadSiteSchedulesCancel = params => {
  return { type: "LOAD_SITE_SCHEDULES_CANCEL", ...params };
};

// SCHEDULE ACTIONS
export const setSiteSchedulesCoreEditing = params => {
  return { type: "SET_SITE_SCHEDULES_CORE_EDITING", ...params };
};
export const setSiteSchedulesCoreSaving = params => {
  return { type: "SET_SITE_SCHEDULES_CORE_SAVING", ...params };
};
export const setSiteSchedulesCoreResetting = params => {
  return { type: "SET_SITE_SCHEDULES_CORE_RESETTING", ...params };
};

// LOAD USERS
export const loadSingleSiteUsersStart = params => {
  return { type: "LOAD_SINGLE_SITE_USERS_START", ...params };
};
export const loadSingleSiteUsersSuccess = params => {
  return { type: "LOAD_SINGLE_SITE_USERS_SUCCESS", ...params };
};
export const loadSingleSiteUsersFailed = params => {
  return { type: "LOAD_SINGLE_SITE_USERS_FAILED", ...params };
};
export const loadSingleSiteUsersCancel = params => {
  return { type: "LOAD_SINGLE_SITE_USERS_CANCEL", ...params };
};

// INVITE USER
export const singleSiteUserGrantAccessStart = params => {
  return { ...params, type: "SINGLE_SITE_USER_GRANT_ACCESS_START" };
};
export const singleSiteUserGrantAccessSuccess = params => {
  return { ...params, type: "SINGLE_SITE_USER_GRANT_ACCESS_SUCCESS" };
};
export const singleSiteUserGrantAccessFailed = params => {
  return { ...params, type: "SINGLE_SITE_USER_GRANT_ACCESS_FAILED" };
};
export const singleSiteUserGrantAccessCancel = params => {
  return { ...params, type: "SINGLE_SITE_USER_GRANT_ACCESS_CANCEL" };
};
export const singleSiteUserGrantAccessNotified = params => {
  return { ...params, type: "SINGLE_SITE_USER_GRANT_ACCESS_NOTIFIED" };
};

// REMOVE USER
export const singleSiteUserRemoveStart = params => {
  return { ...params, type: "SINGLE_SITE_USER_REMOVE_START" };
};
export const singleSiteUserRemoveSuccess = params => {
  return { ...params, type: "SINGLE_SITE_USER_REMOVE_SUCCESS" };
};
export const singleSiteUserRemoveFailed = params => {
  return { ...params, type: "SINGLE_SITE_USER_REMOVE_FAILED" };
};
export const singleSiteUserRemoveCancel = params => {
  return { ...params, type: "SINGLE_SITE_USER_REMOVE_CANCEL" };
};
export const singleSiteUserRemoveNotified = params => {
  return { ...params, type: "SINGLE_SITE_USER_REMOVE_NOTIFIED" };
};